import { jsx as _jsx } from "react/jsx-runtime";
import { byPrefixAndName } from '@awesome.me/kit-f16c5d7bca/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo } from 'react';
export function useCommandsMode({ onModeChange, search }) {
    const commands = useMemo(() => [
        {
            id: 'feature-flags',
            label: 'Feature Flags',
            description: 'Toggle feature flags on or off',
            icon: _jsx(FontAwesomeIcon, { icon: byPrefixAndName['fad']['flag'] }),
            onSelect: () => onModeChange('feature-flags')
        }
    ], [onModeChange]);
    const filteredCommands = useMemo(() => {
        const normalizedSearch = search.trim().toLowerCase();
        if (!normalizedSearch)
            return commands;
        return commands.filter(command => command.label.toLowerCase().includes(normalizedSearch) ||
            command.description.toLowerCase().includes(normalizedSearch));
    }, [commands, search]);
    return { commands: filteredCommands };
}
